import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { DepositsService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class DepositListWithFolderAndStandardBloc extends Bloc<
    DepositsService['depositControllerGetDepositsWithFolderAndStandardByProject']
> {
    public constructor(service: DepositsService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.depositControllerGetDepositsWithFolderAndStandardByProject.bind(service), {
            debug: debug ?? false,
        });
    }
}
